import { LoggerService } from './logger.service';
import { TranslateService } from '@ngx-translate/core';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, of, timer, interval } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';
import { map, flatMap, catchError } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environments/environment';
import { LoginResponse } from 'src/app/state/user.reducer';

export class AuthServiceConfig {
  enabled: boolean = false;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private loggedInSource = new Subject();
  private loggedOutSource = new Subject();

  loggedIn$ = this.loggedInSource.asObservable();
  loggedOut$ = this.loggedOutSource.asObservable();

  _enabled: boolean = false;
  idToken: string;
  refreshSubscription: any;

  constructor(
    @Optional() config: AuthServiceConfig,
    private http: HttpClient,
    private jwtHelper: JwtHelperService,
    private translate: TranslateService,
    private localStorage: LocalStorageService,
    private logger: LoggerService
  ) {
    if (config) {
      this._enabled = config.enabled;
    }
  }

  public isTokenExpired(token: string) {
    // Check if there's an unexpired JWT
    return this.jwtHelper.isTokenExpired(token);
  }

  // public scheduleRefresh() {
  //   // If the user is authenticated, flatMap the token
  //   let source = of(this.idToken).pipe(
  //     flatMap((token) => {
  //       // The delay to generate in this case is the difference
  //       // between the expiry time and the issued at time
  //       let jwtIat = this.jwtHelper.decodeToken(token).orig_iat;
  //       let jwtExp = this.jwtHelper.decodeToken(token).exp;
  //       let iat = new Date(0);
  //       let exp = new Date(0);

  //       let delay = (exp.setUTCSeconds(jwtExp) - iat.setUTCSeconds(jwtIat)) / 2;
  //       console.log('scheduling refresh: ', delay);
  //       return interval(delay);
  //     })
  //   );
  //   this.refreshSubscription = source.subscribe(() => {
  //     this.getNewJwt();
  //   });
  // }

  // public startupTokenRefresh() {
  //   this.idToken = this.localStorage.retrieve('access_token');
  //   // If the user is authenticated, use the token stream
  //   // provided by angular2-jwt and flatMap the token
  //   if (this.loggedIn()) {
  //     let source = of(this.idToken).pipe(
  //       flatMap((token) => {
  //         // Get the expiry time to generate
  //         // a delay in milliseconds
  //         let now: number = new Date().valueOf();
  //         let jwtExp: number = this.jwtHelper.decodeToken(token).exp;
  //         let exp: Date = new Date(0);
  //         exp.setUTCSeconds(jwtExp);
  //         let delay: number = exp.valueOf() - now;

  //         console.info(`token refresh in ${delay / 1000} seconds`);
  //         // Use the delay in a timer to
  //         // run the refresh at the proper time
  //         return timer(delay);
  //       })
  //     );

  //     // Once the delay time from above is
  //     // reached, get a new JWT and schedule
  //     // additional refreshes
  //     source.subscribe(() => {
  //       this.getNewJwt();
  //       this.scheduleRefresh();
  //     });

  //     // Raise logged in
  //     this.loggedInSource.next();
  //   }
  // }

  // public unscheduleRefresh() {
  //   // Unsubscribe from the refresh
  //   if (this.refreshSubscription) {
  //     this.refreshSubscription.unsubscribe();
  //   }
  // }

  // public getNewJwt() {
  //   // Get a new JWT using the token saved in local storage
  //   let url = environment.apiUrl.slice(0, -3) + '/api-token-refresh/';
  //   let headers = new HttpHeaders();
  //   this.localStorage.retrieve('access_token').then((token) => {
  //     headers.append('Content-Type', 'application/json');
  //     let body = JSON.stringify({ token: token });
  //     return this.http.post(url, body).pipe(
  //       map((res) => {
  //         const token = (res as any).token;
  //         this.localStorage.store('access_token', token);
  //         this.idToken = token;
  //         return res || {};
  //       }),
  //       catchError(this.handleError)
  //     );
  //   });
  // }

  // public getToken(): string {
  //   return this.localStorage.retrieve('access_token');
  // }

  // public logout() {
  //   // Remove auth token
  //   this.idToken = null;
  //   this.localStorage.clear('access_token');
  //   // remove config
  //   this.configuration.reset();
  //   // Unschedule the token refresh
  //   this.unscheduleRefresh();
  //   // notify
  //   this.loggedOutSource.next();
  // }

  public login(macAddress: string) {
    let encodedUUID = window.btoa(macAddress);
    let authHeader = `UUID ${encodedUUID}`;
    let authEndpoint = `${environment.apiUrl.slice(0, -3)}/stb/api-token-auth/`;

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', authHeader);
    return this.http.post(authEndpoint, {}, { headers }).pipe(
      map(this.extractAndStoreToken, this),
      map((responseBody) => {
        this.loggedInSource.next();
        return responseBody;
      }),
      catchError(this.handleError)
    );
  }

  private extractAndStoreToken(data: any) {
    this.idToken = data.token;

    // store auth token
    // this.localStorage.store('access_token', data.token);

    // add resident to configuration
    // this.configuration.resident = data.user;

    // add set top box to configuration
    // this.configuration.setTopBox = data.user.set_top_box;

    // add macAddress to configuration
    // this.configuration.macAddress = data.user.hardware_id;

    // Save updated configuration
    // this.configuration.save();

    // Set translation language
    this.translate.use(data.user.locale);

    // Schedule a token refresh
    // this.scheduleRefresh();
    return data || {};
  }

  // private extractAndStoreRefreshToken(data: any) {
  //   localStorage.setItem('access_token', data.token);
  //   return data || {};
  // }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

  getNewJwt(token: string) {
    // Get a new JWT using the token saved in local storage
    let url = environment.apiUrl.slice(0, -3) + '/api-token-refresh/';
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    let body = JSON.stringify({ token });
    return this.http.post(url, body, { headers }).pipe(
      map((response: LoginResponse) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }
}
